import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/collections")({
  component: RouteComponent,
  beforeLoad({ context: { auth } }) {
    if (auth.permissions.cannot("show", "custom-list")) {
      throw redirect({
        to: "/",
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
